export default {
  'side-setting': {
    layout: 'Change Layout',
    'fix-header': 'Fix Header',
    'fix-sidebar': 'Fix Sidebar',
    'content-area': 'Content Area Display',
    'hide-footer': 'Hide Footer',
    'hide-top': 'Hide Top',
    'hide-menu': 'Hide Menu',
    'hide-menu-head': 'Hide Menu Head',
    notice:
      'The configuration bar only provides preview of dynamic layout switching in this site. You can manually copy and modify related configuration files and clear the localStorage cache.',
    'copy-config': 'Copy Config',
    'copy-summary': 'Copy Successfully',
    'copy-content':
      'Please modify config file in src/app/@shared/layouts/da-layout/default-layout.config.ts',
    'sidebar-notice': {
      'can-config': 'Choose weather to fix sidebar',
      'cannot-config': 'This config can only be used when there is a sidebar',
    },
    helpContent:
      'We only show you the switch of different layouts here, see more info in our document.',
  },
};
